import { render, staticRenderFns } from "./AutoHelpFacilities.vue?vue&type=template&id=5f1d7610&scoped=true&"
import script from "./AutoHelpFacilities.vue?vue&type=script&lang=js&"
export * from "./AutoHelpFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d7610",
  null
  
)

export default component.exports